import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimeZoneComponent } from './date-time-zone.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [DateTimeZoneComponent],
    imports: [
      CommonModule,
      NgbModule,
      FormsModule,
      ReactiveFormsModule,
      NgSelectModule
    ],
    exports: [DateTimeZoneComponent]
  })
  export class DateTimeZoneModule { }